import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import PriceParrotService from '~/services/PriceParrotService';

import { controlCentreQueryKeys } from './controlCentreQueryKeys';

export function useCreateConnectivityAction() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (propertyId: string) => {
      return await PriceParrotService.createConnectivityAction({ propertyId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: controlCentreQueryKeys.all });
      enqueueSnackbar('Connectivity action created successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to create connectivity action: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
